import {
  DeleteFileParams,
  DeleteFilesParams,
  GetFileParams,
  GetFilesParams,
  UploadFilesBase,
} from "./types";
import { buildQueryParams } from "./utils";

export const getFile = (params: GetFileParams): string =>
  `api/Database/GetFileBase64${buildQueryParams(params)}`;

export const getFiles = (params: GetFilesParams): string =>
  `api/Database/GetFiles${buildQueryParams(params)}`;

export const uploadFile = (params: UploadFilesBase): string =>
  `api/Database/UploadFile${buildQueryParams(params)}`;

export const uploadFiles = (params: UploadFilesBase): string =>
  `api/Database/UploadFiles${buildQueryParams(params)}`;

export const deleteFile = (params: DeleteFileParams): string =>
  `api/Database/DeleteFile${buildQueryParams(params)}`;

export const deleteFiles = (params: DeleteFilesParams): string =>
  `api/Database/DeleteFiles${buildQueryParams(params)}`;
